module.exports = __webpack_public_path__ + "static/brand-0d58db9698bcd421ea2f14edca8c24d1.svg";